import { createAction, props } from '@ngrx/store';

export const setOrder = createAction('setOrder', props<{ data: any }>());

export const setRotationOrder = createAction(
  'setRotationOrder',
  props<{ data: any }>()
);
